<form [formGroup]="form">
  <div class="d-lg-flex align-items-center mb-2">
    <app-client-autocomplete [(selectedClient)]="selectedClient"
      class="client-autocomplete me-2"></app-client-autocomplete>
    @if (selectedClient) {
      <div class="d-flex align-items-center">
        <label for="startDate" class="control-label required me-2">
          {{'i18n.domain.reports.filter.fields.startDate' | translate}}:
        </label>
        <ejs-datepicker #startTime formControlName="startDate" format="dd.MM.yyyy" class="me-2" id="startDate">
        </ejs-datepicker>
      </div>
      <div class="d-flex align-items-center">
        <label for="endDate" class="control-label required me-2">
          {{'i18n.domain.reports.filter.fields.endDate' | translate}}:
        </label>
        <ejs-datepicker #endTime formControlName="endDate" format="dd.MM.yyyy" class="me-2" id="endDate">
        </ejs-datepicker>
      </div>
      <div class="d-flex align-items-center">
        <label for="zoneId" class="control-label me-2">
          {{'i18n.domain.reports.filter.fields.zone' | translate}}:
        </label>
        <app-autocomplete [getDataFunction]="searchZoneAutocompleteValues.bind(this)"
          [fields]="keyValueDropdownSettings" [(value)]="selectedZone" [isFormComponent]="true"
          placeholder="i18n.domain.reports.filter.fields.zone-dropdown-placeholder" id="zoneId" class="me-2">
        </app-autocomplete>
      </div>
      <div class="d-flex align-items-center">
        <label for="parkerId" class="control-label me-2">
          {{'i18n.domain.reports.filter.fields.parker' | translate}}:
        </label>
        <app-multi-select-filter [getDataFunction]="searchParkerDropdownValues.bind(this)" [(values)]="selectedParkerId"
          [type]="MultiSelectFilterType.MultiSelectItem"
          width="200px"
          placeholder="i18n.domain.reports.filter.fields.parker-dropdown-placeholder" id="parkerId">
        </app-multi-select-filter>
      </div>
    }
  </div>
</form>
